import { Building2, MapPin, Briefcase, Clock, ArrowRight } from "lucide-react";

export default function JobCard({ title, company, location, onView, postedAt = "Publicado há 2 dias", jobType = "Tempo integral" }) {
    return (
        <div
            className="
                bg-white rounded-xl border border-gray-100 shadow-sm 
                hover:shadow-md transition-all duration-300 cursor-pointer
                p-5 w-full mb-4
            "
            onClick={onView}
        >
            {/* Cabeçalho da vaga */}
            <div className="flex justify-between items-start gap-4">
                <div className="flex-1">
                    <h3 className="text-base md:text-lg font-medium text-gray-800 mb-2">
                        {title}
                    </h3>
                    <div className="space-y-1.5">
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <Building2 className="w-4 h-4 text-gray-400" />
                            <span>{company}</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <MapPin className="w-4 h-4 text-gray-400" />
                            <span>{location}</span>
                        </div>
                    </div>
                </div>

                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onView();
                    }}
                    className="
                        inline-flex items-center gap-2
                        bg-emerald-600 hover:bg-emerald-700 
                        text-white text-sm font-medium
                        px-4 py-2 rounded-lg
                        transition-colors shadow-sm
                    "
                >
                    Detalhes
                    <ArrowRight className="w-3.5 h-3.5" />
                </button>
            </div>

            {/* Rodapé da vaga */}
            <div className="
                flex justify-between items-center
                text-xs text-gray-400
                mt-4 pt-4 border-t border-gray-100
            ">
                <div className="flex items-center gap-1.5">
                    <Clock className="w-3.5 h-3.5" />
                    <span>{postedAt}</span>
                </div>
                <div className="flex items-center gap-1.5">
                    <Briefcase className="w-3.5 h-3.5" />
                    <span>{jobType}</span>
                </div>
            </div>
        </div>
    );
}